import { createSelector } from 'reselect';

import getApplicationSelector from './getApplicationSelector';
import { hasReducePageUnlockedSelector } from './basket_meta/getBasketMetaSelector';

export default createSelector(
  [getApplicationSelector, hasReducePageUnlockedSelector],
  (application, reducePageUnlocked) => application?.reducePageUnlocked || reducePageUnlocked,
);
